<template>
  <navbar
    position="fixed"
    type="white"
    menu-classes="ml-auto"
  >
    <template slot-scope="{ toggle, isToggled }">
      <div class="cd-topnav-right-mob" fxhide="" fxlayout="row" fxshow.lt-md="" style="flex-direction: row; box-sizing: border-box; display: flex;">
        <div id="smallAddress"  @click="showPanel()" class="cd-topnav-headers mr-13 ht-42 ng-star-inserted" fxlayoutalign="center center" style="font-family: 'Lato Regular';
            font-weight: bold; cursor:pointer"> Select Location
          <img alt="expand" height=8 width=8 class="pd-5" src="img/downarrow.png" style="margin-left:5px">
        </div>
        <div style="display:none">
         <input type="hidden" id="headerLat" />
         <input type="hidden" id="headerLng" />
         <input type="hidden" id="hfullAddress" />
        </div>
        <b-modal ref="address" id="bv-modal-address" size="xl" no-close-on-backdrop no-close-on-esc hide-footer >
              <template v-slot:modal-title>
                  <img alt="doodhvale logo" src='img/d-logo.png'>
              </template>
              <div class="row">
            <div class="col-12 col-sm-3 col-md-3">
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <div class="userAddress-block text-center ui-front">
                <div class="headerAddressSection">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12">
                          <p><a @click.prevent="clearAddress()" class="underlineText edit_location">Clear Address</a></p>
                          <gmap-autocomplete @place_changed="setPlace" :select-first-on-enter="true" :value='formattedAddress' id="userAddress" class="form-control" placeholder="Search Location" style="width:100%"></gmap-autocomplete>
                          <div class="error-address" id="madal-error-address">please fill address</div>
                        </div>
                      </div>
                      <br>
                      <div class="row">
                          <div class="col-12 col-sm-12 col-md-12 ">

                          <button mat-raised-button="" v-on:click.prevent="userLocation()" class="mat-raised-button ng-star-inserted btn btn-lg btn-block userAddress"  value="" >Pick Current Location
                          <div class="mat-button-ripple mat-ripple" matripple=""></div>
                          <div class="mat-button-focus-overlay"></div>
                        </button>
                          </div>
                          
                          <!--div class="col-12 col-sm-12 col-md-12">  
                            <a @click.prevent="showMap()" style="float:right" id="header-map1 " class="userAddress btn btn-info btn-block">Show Map</a>
                          </div-->
                        </div>
                      <div v-if="showmap" id="usermap">
                        <gmap-map ref="usergmap" v-bind:center='center' @dragend="updateCoordinates" @click="updateCoordinates" v-bind:zoom='16' style='height: 300px' v-bind:options='{disableDefaultUI: true, zoomControl: true}'>
                          <gmap-marker v-bind:key='index' v-for='(m, index) in markers' v-bind:position="m.position"  v-bind:clickable='true' v-bind:draggable="true" @dragend="updateCoordinates"></gmap-marker>
                        </gmap-map>
                        <br>
                        <textarea  style="color: gray; font-style: italic;width:100%;display:none;" class="location_edit1" id="user_loc" placeholder="Pick address from map" readonly="true" ></textarea>
                       
                        <br>
                      </div>
                  <!-- address-card-row-first-end -->
                  <!-- address-card-row-second-start -->
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-12 col-sm-12 col-md-12 ">
               <div class="dv-btn" fxlayoutalign="center center" style="place-content: center; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;">             
                  <button mat-raised-button="" v-on:click.prevent="closePanel()" class="mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn"  value="" ><span class="mat-button-wrapper">Save & Continue</span>
                    <div class="mat-button-ripple mat-ripple" matripple=""></div>
                    <div class="mat-button-focus-overlay"></div>
                  </button>  
                </div>
                </div>
              </div>
             </div>
             <div class="col-12 col-sm-3 col-md-3 "></div> 
          </div> 
          </b-modal>
      </div>

      <router-link v-popover:popover1 class="navbar-brand" to="/">
        <img alt="doodhvale logo" src='img/d-logo.png'>
      </router-link>
    </template>
  </navbar>
  
</template>

<script>
//import Vue from 'vue';
import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
import { gmapApi } from "vue2-google-maps";
import { Popover } from 'element-ui';
import axios from 'axios';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover
  },
  computed: {
    google: gmapApi
  },
  created() {
    this.userLocation()
  },
  data() {
    return {
      center: { lat: 28.664081, lng: 77.389001 },
      markers: [
        {
          position: { lat: 28.664081, lng: 77.389001 }
        }
      ],
      showmap: false,
      pincode: '000000',
      city: 'North Delhi',
      country: '',
      state: '',
      locality: '',
      formattedAddress: '',
      address1: '',
      address2: '',
      fullAddress: []
    }
  },
  methods: {
    showPanel() {
      if(document.getElementById('hfullAddress').value){
        this.formattedAddress = document.getElementById('hfullAddress').value
      }
      this.$refs['address'].show()
    },
    closePanel() {
      //debugger
      //this.address(this.markers[0].position.lat, this.markers[0].position.lng)
      this.$refs['address'].hide()
    },
    showMap(){
      if(this.showmap == false){
        document.getElementById('header-map1').innerHTML="Hide Map";
        this.showmap = true
      }else{
        document.getElementById('header-map1').innerHTML="Show Map";
        this.showmap = false
      }
    },
    async setPlace(place) {  
      this.showmap = false  
      //document.getElementById('header-map1').innerHTML="Show Map";  
      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      }
      this.markers[0].position.lat = place.geometry.location.lat()
      this.markers[0].position.lng = place.geometry.location.lng()
      if(document.getElementById('headerLat') && document.getElementById('headerLat')){
          document.getElementById('headerLat').value = this.markers[0].position.lat
          document.getElementById('headerLng').value = this.markers[0].position.lng
          document.getElementById('hfullAddress').value = place.formatted_address
        }
        if (document.getElementById('searchAddress')) {
          document.getElementById('searchAddress').innerHTML = place.formatted_address
        }
        this.fullAddress = place.address_components
        this.formattedAddress = place.formatted_address
        this.fillAddress()                     
      //this.updateCenter(place.geometry.location);
    },
    /* updateCenter(location) {
      this.center = {
        lat: location.lat(),
        lng: location.lng(),
      }
      this.markers[0].position.lat = location.lat()
      this.markers[0].position.lng = location.lng()
      //this.address(this.markers[0].position.lat, this.markers[0].position.lng)
    },    
    updateCoordinates (location) {
      //document.getElementById('userAddress').value = ''
      this.markers[0].position.lat = location.latLng.lat()
      this.markers[0].position.lng = location.latLng.lng()
      this.address(this.markers[0].position.lat, this.markers[0].position.lng)
    },  */
    /* address (lats, lngs) {
        debugger
        let latlng = {lat: lats, lng: lngs}
        const google = window.google
        // alert(google)
        if (google !== undefined) {
          var geocoder = new google.maps.Geocoder()
          var myScope = this
          await geocoder.geocode({'location': latlng}, function (results, status) {
            if (status === 'OK') {
              if (results[0]) {
                if(document.getElementById('headerLat') && document.getElementById('headerLat')){
                  document.getElementById('headerLat').value = lats
                  document.getElementById('headerLng').value = lngs
                  
                }
                //myScope.fillAddress(results)
                myScope.fullAddress = results
                let full_address = myScope.fullAddress
                if (document.getElementById('user_loc')) {
                  document.getElementById('user_loc').value = full_address[0].formatted_address
                }
                if (document.getElementById('userAddress')) {
                  document.getElementById('userAddress').value = full_address[0].formatted_address
                }
                myScope.pincode = full_address[0].address_components[8].long_name
                myScope.country = full_address[0].address_components[7].long_name
                myScope.state = full_address[0].address_components[6].long_name
                myScope.city = full_address[0].address_components[5].long_name
                myScope.locality = full_address[0].address_components[4].long_name
                myScope.formattedAddress = full_address[0].formatted_address
                let sublocality_level_1 = full_address[0].address_components[3].long_name
                let sublocality_level_2 = full_address[0].address_components[2].long_name
                let sublocality_level_3 = full_address[0].address_components[1].long_name
                let smallAddress = ''
                if(sublocality_level_3){
                    smallAddress = sublocality_level_3
                }else if (sublocality_level_2) {
                  smallAddress = sublocality_level_2
                }else if(sublocality_level_1) {
                  smallAddress = sublocality_level_1
                }else if(myScope.locality) {
                  smallAddress = myScope.locality
                }else{
                  smallAddress = ''
                }
                smallAddress = smallAddress + ', ' + myScope.pincode
                var smAdd = document.getElementById('smallAddress');
                var text_to_change = smAdd.childNodes[0];
                text_to_change.nodeValue = smallAddress;
              } else {
                window.alert('No location found')
              }
            } else {
              //window.alert('Geocoder failed due to: ' + status);
            }
          })
        } else {
          //window.alert('Geocoder failed due to: ' + status);
        }
      }, */
    
    async userLocation(){
      // debugger
      if (navigator.geolocation) {
      await navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.markers[0].position.lat = position.coords.latitude
        this.markers[0].position.lng = position.coords.longitude
        if(document.getElementById('headerLat') && document.getElementById('headerLat')){
          document.getElementById('headerLat').value = this.markers[0].position.lat
          document.getElementById('headerLng').value = this.markers[0].position.lng
        }
        var myScope = this 
        //this.fillAddress(this.markers[0].position.lat, this.markers[0].position.lng)
        axios.get("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + this.markers[0].position.lat + "," + this.markers[0].position.lng + "&key=AIzaSyArGgueGCb2p4sqjU4pScADLskS9OxZ8jQ")
        .then((response) => {
          myScope.fullAddress = response.data.results[0].address_components
          myScope.formattedAddress = response.data.results[0].formatted_address
          if(document.getElementById('hfullAddress')){
            document.getElementById('hfullAddress').value = response.data.results[0].formatted_address
          }
          if (document.getElementById('searchAddress')) {
            document.getElementById('searchAddress').innerHTML = response.data.results[0].formatted_address
          }
          myScope.fillAddress()
          });
        }, error => {
          switch(error.code) {
              case error.PERMISSION_DENIED:
                alert("location setting off, Please enable location setting.")
                break;
              case error.POSITION_UNAVAILABLE:
                alert( "Location information is unavailable.")
                break;
              case error.TIMEOUT:
                alert( "The request to get user location timed out.")
                break;
              case error.UNKNOWN_ERROR:
                alert( "An unknown error occurred.")
                break;
              default:
                alert( "Location information is unavailable.")
            }
        });
      }else{
        alert("location setting off, Please enable location setting.")
      }
    },
    clearAddress(){
      document.getElementById('userAddress').value = ''
    },
    fillAddress(){
      //debugger
          let full_address = this.fullAddress
          if (document.getElementById('user_loc')) {
            document.getElementById('user_loc').value = this.formattedAddress
          }
          if (document.getElementById('userAddress')) {
            document.getElementById('userAddress').value = this.formattedAddress
          }
          let sublocality_level_1 = '';
          let sublocality_level_2 = '';
          let sublocality_level_3 = '';
          let locality = '';
          for (var i = 0; i < full_address.length; i++) {
              if (full_address[i].types.includes("sublocality_level_1")){ sublocality_level_1 = full_address[i].long_name; }    
              if (full_address[i].types.includes("sublocality_level_2")){ sublocality_level_2 = full_address[i].long_name; }
              if (full_address[i].types.includes("sublocality_level_3")){ sublocality_level_3 = full_address[i].long_name; }    
              if (full_address[i].types.includes("locality")){ locality = full_address[i].long_name; }
              if (full_address[i].types.includes("administrative_area_level_2")){ this.city = full_address[i].long_name; }    
              if (full_address[i].types.includes("administrative_area_level_1")){ this.state = full_address[i].long_name; }
              if (full_address[i].types.includes("country")){ this.country = full_address[i].long_name; }
              if (full_address[i].types.includes("postal_code")){ this.pincode = full_address[i].long_name; }    
              
          }
         /*  this.pincode = full_address[8].long_name
          this.country = full_address[7].long_name
          this.state = full_address[6].long_name
          this.city = full_address[5].long_name
          this.locality = full_address[4].long_name
          //this.formattedAddress = full_address[0].formatted_address
          let sublocality_level_1 = full_address[3].long_name
          let sublocality_level_2 = full_address[2].long_name
          let sublocality_level_3 = full_address[1].long_name */
          let smallAddress = ''
          if(sublocality_level_2){
              smallAddress = sublocality_level_2
          }else if (sublocality_level_3) {
            smallAddress = smallAddress + ' ' + sublocality_level_3
          }else if(sublocality_level_1) {
            smallAddress = sublocality_level_1
          }else if(this.locality) {
            smallAddress = this.locality
          }else{
            smallAddress = ''
          }
          smallAddress = smallAddress + ', ' + this.pincode
          var smAdd = document.getElementById('smallAddress');
          var text_to_change = smAdd.childNodes[0];
          text_to_change.nodeValue = smallAddress;
        //}) 
    },
  } 
};
</script>

<style scoped>
</style>
